import { environment } from '@env/environment';

/** Only send OAuth credentials to APIs owned by WOLOP. */
export const oauthResourceServerConfig = {
  allowedUrls: [
    environment.API_AUTH_BASE + '/api/v1/',
    environment.API_AUTH_BASE + '/op/userinfo',
    environment.API_CONFIGURATION_BASE + '/',
    environment.API_DOMAIN,
    environment.API_ENTERPRISE_BASE + '/',
    environment.API_WOLOP_INVENTORY + '/',
    environment.API_WOLOP_ACCOUNTING + '/',
    environment.API_WOLOP_REPORT + '/',
    environment.API_WOLOP_ROUTER + '/',
  ],
  // oauthTokenInterceptor adds the bearer while preserving explicit Authorization headers.
  sendAccessToken: false,
  customUrlValidation: isOAuthProtectedResource,
};

export function isOAuthProtectedResource(url: string): boolean {
  const requestUrl = parseUrl(url);
  if (!requestUrl) return false;

  return oauthResourceServerConfig.allowedUrls.some((allowedUrl) => {
    const allowed = parseUrl(allowedUrl);
    if (!allowed || allowed.origin !== requestUrl.origin) return false;

    const basePath = allowed.pathname.replace(/\/$/, '');
    return requestUrl.pathname === basePath || requestUrl.pathname.startsWith(basePath + '/');
  });
}

function parseUrl(url: string): URL | null {
  try {
    return new URL(url);
  } catch {
    return null;
  }
}
